import React from 'react';
import ModalCard, { modalSize } from 'shared-assets/components/Modal/ModalCard';
import { Box, Typography } from '@kareo/design-system';
var PatientEducationModal = function (_a) {
    var isOpen = _a.isOpen, onClose = _a.onClose, ptEdUrl = _a.ptEdUrl;
    return (React.createElement(ModalCard, { header: React.createElement(Typography, { variant: "h2", component: "div" }, "Patient Education"), open: isOpen, onClose: onClose, size: modalSize.large },
        React.createElement(Box, { height: 500 },
            React.createElement("iframe", { title: "Pt. Education", src: ptEdUrl, width: "100%", height: "100%" }))));
};
export default PatientEducationModal;
